import { CircularProgress, Backdrop } from '@mui/material';

interface BaseLoadingProps {
    open?: boolean;
}

export default function BaseLoading({ open }: BaseLoadingProps) {
    return (
        <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={!!open}>
            <CircularProgress size={40} sx={{ mb: 2 }} />
        </Backdrop>
    );
}
